<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    Detail {{ $t("overTime") }}
                  </h6>
                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseExample"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div
                    class="row mb-3 collapse"
                    id="collapseExample"
                    style="padding-left: 20px"
                  >
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created By:</label>
                      <p class="text-muted">{{ this.forms.create_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{ this.forms.created_at }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{ this.forms.update_by }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{ this.forms.updated_at }}</p>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div class="row">
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("customerId_txt") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.customer_id"
                            disabled
                          />

                          <div v-if="errors.customer_id">
                            <div
                              v-for="error in errors.customer_id"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("fulfillment_code") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.warehouse_id"
                            disabled
                          />
                          <div v-if="errors.warehouse_id">
                            <div
                              v-for="error in errors.warehouse_id"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("employeeIdTxt") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            :value="
                              forms.id_employee + ' - ' + forms.name_employee
                            "
                            disabled
                          />
                          <div v-if="errors.id_employee">
                            <div
                              v-for="error in errors.id_employee"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("overtimeCostId") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            :value="
                              forms.cost_center_overtime_code +
                              ' | ' +
                              forms.cost_center_overtime_description
                            "
                            disabled
                          />
                          <div v-if="errors.cost_center_overtime_code">
                            <div
                              v-for="error in errors.cost_center_overtime_code"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("overtimeType") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.ot_type_desc"
                            disabled
                          />
                          <div v-if="errors.ot_type">
                            <div
                              v-for="error in errors.ot_type"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("totalWorkDay") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            v-model="forms.amount_of_work_description"
                            disabled
                          />

                          <div v-if="errors.amount_of_work">
                            <div
                              v-for="error in errors.amount_of_work"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-5">
                          <div class="row">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("overtimeDateTxt") }}</label
                              >
                            </div>
                            <div class="col-lg-7">
                              <date-picker
                                v-model="forms.ot_date"
                                input-class="form-control"
                                placeholder="YYYY-MM-DD"
                                format="YYYY-MM-DD"
                                value-type="format"
                                type="date"
                                disabled
                              ></date-picker>

                              <div v-if="errors.ot_date">
                                <div
                                  v-for="error in errors.ot_date"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-5">
                          <div class="row">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("breakTime") }}</label
                              >
                            </div>
                            <div class="col-lg-6">
                              <input
                                type="number"
                                class="form-control"
                                v-model="forms.break_value"
                                disabled
                              />

                              <div v-if="errors.break_value">
                                <div
                                  v-for="error in errors.break_value"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-5">
                          <div class="row">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("startOvertime") }}</label
                              >
                            </div>
                            <div class="col-lg-6">
                              <input
                                type="text"
                                class="form-control"
                                :value="forms.ot_value_start"
                                disabled
                              />

                              <div v-if="errors.ot_value_start">
                                <div
                                  v-for="error in errors.ot_value_start"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-5">
                          <div class="row">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("endOvertime") }}</label
                              >
                            </div>
                            <div class="col-lg-6">
                              <input
                                type="text"
                                class="form-control"
                                :value="forms.ot_value_end"
                                disabled
                              />

                              <div v-if="errors.ot_value_end">
                                <div
                                  v-for="error in errors.ot_value_end"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-5">
                          <div class="row mb-3">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("overtimeType") }}</label
                              >
                            </div>
                            <div class="col-lg-6">
                              <input type="text" class="form-control" :value="forms.type_data" readonly>
                            </div>
                          </div>
                        </div>
                        <div class="col-5">
                          <div class="row mb-3">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("actualOvertime") }}</label
                              >
                            </div>
                            <div class="col-lg-6">
                              <input type="text" :value="forms.is_actual_overtime ? 'YES' : 'NO'" class="form-control" readonly>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("keterangan") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <textarea
                            type="text"
                            class="form-control"
                            id="catatan"
                            :placeholder="$t('keterangan')"
                           :value="forms.catatan"
                            disabled
                          ></textarea>
                          <div v-if="errors.catatan">
                            <div
                              v-for="error in errors.catatan"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("Cost") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="fulfillment_code"
                            :placeholder="$t('fulfillment_code')"
                            :value="
                              forms?.cost ? forms.cost : 0 | format_number
                            "
                            disabled
                          />
                          <div v-if="errors.warehouse_id">
                            <div
                              v-for="error in errors.warehouse_id"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("splImages") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <img
                            :src="forms.spl_file_url"
                            style="
                              max-height: 300px;
                              cursor: pointer;
                              width: auto;
                            "
                            @click="
                              visible = true;
                              imageIndex = 1;
                            "
                          />
                          <div v-if="errors.spl_image">
                            <div></div>
                            <div
                              v-for="error in errors.spl_image"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <a
                        v-if="
                          permision_role.method_delete &&
                          forms.status == 'active'
                        "
                        class="btn btn-danger text-white fw-bolder btn-icon-text float-end"
                        @click="deleteData('deactivate')"
                      >
                        <i class="link-icon" data-feather="trash"></i>
                        {{ $t("deactive_txt") }}
                      </a>

                      <a
                        v-if="
                          permision_role.method_delete &&
                          forms.status == 'deactivate'
                        "
                        class="btn btn-success text-white fw-bolder btn-icon-text float-end"
                        @click="deleteData('active')"
                      >
                        <i class="link-icon" data-feather="trash"></i>
                        {{ $t("active_txt") }}
                      </a>
                      <!-- <a
                        v-if="permision_role.method_delete"
                        class="
                          btn btn-danger
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="deleteData()"
                      >
                        <i class="link-icon" data-feather="trash"></i>
                        {{ $t("deleteMess") }}
                      </a> -->

                      <!-- <a
                        v-if="permision_role.method_update"
                        class="
                          btn btn-primary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="editData()"
                      >
                        <i class="link-icon" data-feather="edit"></i>
                        {{ $t("editMess") }}
                      </a> -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <vue-easy-lightbox
          escDisabled
          moveDisabled
          :visible="visible"
          :imgs="imgSrc"
          :index="imageIndex"
          @hide="handleHide"
        ></vue-easy-lightbox>
        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/id";
import VueEasyLightbox from "vue-easy-lightbox";

export default {
  name: "UsersDetail",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DatePicker,
    VueEasyLightbox,
  },
  data() {
    return {
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      fetchRole: [],
      fetchCompany: [],
      permision_role: [],
      forms: [],
      selectedEmployee: null,
      fetchTypeOvertime: [],
      selectedTypeOvertime: null,
      fetchWorkDays: [],
      selectedWorkDays: null,
      fetchCostOvertime: [],
      selectedCostOvertime: null,
      enableEmploye: true,
      imageIndex: 0,
      imgSrc: "",
      visible: false,
    };
  },
  watch: {},
  methods: {
    resetForm() {
      this.forms.name = "";
      this.forms.username = "";
      this.forms.password = "";
      this.forms.email = "";
      this.forms.company_id = "";
      this.forms.role_id = "";
    },

    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },
    handleHide() {
      this.visible = false;
    },

    editData() {
      var params = this.$route.params.id;
      window.location.href = "/user-access/edit/" + params;
    },

    deleteData(status) {
      var id = this.$onBehind(this.$route.params.id);
      this.$swal({
        title: this.$t("areYouSure"),
        text: status,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endpointWhMonitoring +
            "v1/overtime/update-status/" +
            id;
          this.$http
            .patch(baseURI, formData, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/wh-monitoring/overtime";
                // this.loadData(this.$route.params.id);
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    backForm() {
      window.location.href = "/wh-monitoring/overtime";
    },

    loadData(id) {
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/overtime/detail/" + id;
      this.isLoading = true;
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.forms = response.data.datas;
          this.imgSrc = this.forms.spl_file_url;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    submitData() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.fade(true);
          // let params = this.$onBehind(this.$route.params.id);
          // let formData = new FormData();
          // formData.append("name", this.forms.name);
          // formData.append("username", this.forms.username);
          // formData.append("password", this.forms.password);
          // formData.append("email", this.forms.email);
          // formData.append("company_id", this.forms.company_id);
          // formData.append("role_id", this.forms.role_id);
          // formData.append("status", 'active');

          const baseURI = this.$settings.endPoint + "users/" + this.forms.id;
          this.$http
            .patch(baseURI, this.forms, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.resetForm();
                this.errors = [];
                this.success(response.data.datas.messages);

                //window.history.back();
                var params = this.$onRandom(this.forms.id);
                window.location.href = "/user-access/detail/" + params;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission !== null &&
          permision.permission.controller == "WhMonitoringOvertimeController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
  },
  events: {},
  created: function () {},
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    this.fetchIt();
    this.loadData(params[0]);
  },
};
</script>
<style scoped></style>
